import React, { useContext, useEffect, useState } from 'react';
import { NotifyTargetInnerInDTO, NotifyTargetOutDTO } from '@api/ringil-api.v2.tsx';
import { ApiContext } from '@api/api.tsx';
import NotifyDropdown from '@components/RingilComponents/NotifyDropdown.tsx';

interface ComponentProps {
  notifiedTargets: NotifyTargetInnerInDTO[];
  onChange: (notifyTargets: NotifyTargetInnerInDTO[]) => void;
  readonly?: boolean;
}

const NotifyDropdownPlain: React.FC<ComponentProps> = ({ readonly, notifiedTargets, onChange }) => {

  const [internalValue, setInternalValue] = useState<NotifyTargetOutDTO[]>();

  const [notifyTargetsOptions, setNotifyTargetsOptions] = useState<NotifyTargetOutDTO[]>([]);
  const { listNotifyTargets } = useContext(ApiContext);

  useEffect(() => {
    listNotifyTargets(data => setNotifyTargetsOptions(data));
  }, []);

  useEffect(() => {
    setInternalValue(notifyTargetsOptions.filter(values => notifiedTargets?.some(t => t.id === values.id && t.notifyTargetType === values.notifyTargetType)));
  }, [notifyTargetsOptions, notifiedTargets]);

  return (
    <>
      <NotifyDropdown
        notifyTargetOptions={notifyTargetsOptions}
        values={notifyTargetsOptions.filter(values => internalValue?.some(t => t.id === values.id && t.notifyTargetType === values.notifyTargetType))}
        onSelect={values => {
          setInternalValue(values);
          onChange(values);
        }}
        readonly={readonly}
      />
    </>
  );
};

export default NotifyDropdownPlain;
